<template>
  <div class="container shaded">
    <h1 class="title text-center">{{ msg }}</h1>
    <h2>{{ app_name }}</h2>
    <p>
      Este formulario te permite calcular tu número de registro de personal, NRP.
    </p>
    <div class="col-lg-6 offset-lg-3 col-md-12 offset-md-0">
      <dynamic-form :form="nrpForm" @change="valuesChanged" @blur="valuesChanged"/>
    </div>
    <div class="col-12">
      <div class="result">{{ result }}</div>
    </div>
    <div id="version">v {{ app_version }}</div>
  </div>
</template>

<script>
import {
  SelectField,
  TextField,
  Validator,
  required,
  pattern,
} from '@asigloo/vue-dynamic-forms';

const SA = [
  {value: "A", name: "Funcionario de Carrera"},
  {value: "S", name: "Funcionario en prácticas"},
  {value: "Y", name: "Funcionario Interino en sustituciones"},
  {value: "I", name: "Funcionario Interino con vacante"}
];

const CUERPOS = [
  {value: "0590", name: "Profesores de Secundaria"},
  {value: "0591", name: "Profesores Técnicos de Formación Profesional"},
  {value: "0592", name: "Profesores Escuelas Oficiales de Idiomas"},
  {value: "0593", name: "Catedráticos de Música y Artes Escénicas"},
  {value: "0594", name: "Profesores de Música y Artes Escénicas"},
  {value: "0595", name: "Profesores de Artes Plásticas y Diseño"},
  {value: "0596", name: "Maestros de Taller de Artes Plásticas y Diseño"},
  {value: "0597", name: "Maestros"}
]

const dni_valid = (dni) => {
  if (!(dni && dni.length === 8)) return false;
  dni = parseInt(dni);
  return dni > 0 && dni < 99999999;
}

const data = () => ({
  result: "....",
  nrpForm: {
    id: 'nrp-form',
    fields: {
      sa: SelectField({
        options: SA.map(({value, name}) => ({
          value: `${value}`,
          label: `${name} (${value})`,
        })),
        value: null,
        label: 'Situación Administrativa',
        validations: [
          Validator({
            validator: required,
            test: 'La situación administrativa es necesaria'
          })
        ],
      }),
      cuerpo: SelectField({
        options: CUERPOS.map(({value, name}) => ({
          value: `${value}`,
          label: `${name} (${value})`,
        })),
        value: null,
        label: 'Cuerpo',
        validations: [
          Validator({validator: required, text: 'El cuerpo es necesario'}),
        ],
      }),  
      dni: TextField({
        value: null,
        label: 'DNI',
        placeholder: 'solo el número sin la letra',
        validations: [
          Validator({validator: required, text: 'El dni es necesario'}),
          Validator({validator:pattern('^.{8}$',), text: 'El dni debe contener solo 8 números, sin letra'}),
        ],
      })
    },
    options: {
      customClass: 'my-form',
    },
  },
})

const methods = {
  valuesChanged(values) {
    console.log(values);
    this.$forceUpdate(); // this is only to refresh the fields on the <pre> tags, not necessary for other purposes
    this.formData = {
      ...this.formData,
      ...values
    };

    if (this.formData.sa && this.formData.cuerpo && dni_valid(this.formData.dni)) {
      let dni = parseInt(this.formData.dni);
      console.log(dni);
      let seed = dni % 7;
      this.result = dni.toString() + seed.toString() + (seed + 2).toString() + this.formData.sa + this.formData.cuerpo;
    } else {
      this.result = "XXXXXXXXYYACCCC";
    }
  }
};

export default {
  name: 'NRP',
  data,
  methods,
  props: {
    msg: String,
    app_name: String,
    app_version: String
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.shaded {
  background-color: #21252975;
  padding: 4em;
  border-radius: 2em;
  width: 80%;
}
.result {
  font-size: 6vw;
}
#version {
  position: fixed;
  bottom: 0.4em;
  right: 2em;
  color: green;
  font-size: 2em;
  font-family: monospace;
}
</style>
